export const formatAwbLabel = (index: number): string => (index === 0 ? 'MAWB' : `HAWB ${index}`);
